import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'pilz',
} as IModuleProps;
